
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 17 17"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"stroke":"#798F8F","stroke-linecap":"round","d":"M9 10.115 3.615 15.5m0 0v-4.308m0 4.308h4.039m2.423-1.077h3.23c.595 0 1.078-.482 1.078-1.077V2.576c0-.594-.482-1.076-1.077-1.076H6.846c-.595 0-1.077.482-1.077 1.077V8.5m2.154-4.308h4.308M7.923 6.346h4.308"}})])
          )
        }
      }
    